import { random } from "../utils"

export const toast = (message) => {
    //Remove caso já exista um
    let toast = select('#toast')
    toast && toast.remove()

    //Cria o elemento e adiciona ao body
    let el = document.createElement('div')
    el.id = 'toast'
    document.body.appendChild(el)

    $('#toast').removeClass('toast-fideliza')

    //Animação
    $('#toast').text(message).fadeIn(400).delay(3000).fadeOut(400)
}

export const toastFideliza = (message, delay) => {
    //Remove caso já exista um
    let toast = select('#toast')
    toast && toast.remove()

    //Cria o elemento e adiciona ao body
    let el = document.createElement('div')
    el.id = 'toast'
    document.body.appendChild(el)

    //Quando for fideliza, ele usa essa função e coloca essa classe para posicionar o toast no topo da tela do usuário
    $('#toast').addClass('toast-fideliza')

    //Animação
    $('#toast').text(message).fadeIn(400).delay(delay || 2200).fadeOut(400)
}

export const loader = (className) => {
    return `
    <div class="showbox ${className}">
      <div class="loader"> <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
        </svg> </div>
    </div>`
}

export const gif = {
    start: function (message, classList, color) {
        let template = `
        <div id="loading-container">
        <div id="loading" class="${classList ? classList : ''}">
                <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
                    <defs>
                        <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                            <stop stop-color="#d72323" stop-opacity="0" offset="0%" />
                            <stop stop-color="#d72323" stop-opacity=".631" offset="63.146%" />
                            <stop stop-color="#d72323" offset="100%" /> 
                        </linearGradient>
                    </defs>
                    <g fill="none" fill-rule="evenodd">
                        <g transform="translate(1 1)">
                            <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2" transform="rotate(313.244 18 18)">
                                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite" />
                            </path>
                            <circle fill="${color ? color : '#d72323'
            }" cx="36" cy="18" r="1" transform="rotate(313.244 18 18)">
                                <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite" />
                            </circle>
                        </g>
                    </g>
                </svg>
                </div>
                ${message ? '<span id="gif-message">' + message + '</span>' : ''
            }
                </div>`
        return template
    },
    end: (el) => {
        if (el) {
            const target = el.querySelector('#loading')
            if (target) {
                target.remove()
            }
        }

        const fullScreeen = select('#gif-fullScreen')
        if (fullScreeen) {
            fullScreeen.remove()
        }
    },
    fullScreen: (element, msg, classList) => {
        const gifContainer = document.createElement('div')
        gifContainer.id = 'gif-fullScreen'
        gifContainer.classList.add('gif-fullscreen')
        gifContainer.classList += classList ? classList : ''
        gifContainer.innerHTML = gif.start(msg)
        element.append(gifContainer)
    }
}

export const showMessage = (
    title,
    message,
    type,
    buttonText = "Ok",
    callback,
    isMobile,
    classList,
    ask,
) => {
    const icon = {
        success: `
             <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1"
                  x="0px" y="0px" viewBox="0 0 367.805 367.805" style="enable-background:new 0 0 367.805 367.805;"
                  xml:space="preserve">
                  <path style="fill:#22af70;"
                  d="M183.903,0.001c101.566,0,183.902,82.336,183.902,183.902s-82.336,183.902-183.902,183.902   S0.001,285.469,0.001,183.903l0,0C-0.288,82.625,81.579,0.29,182.856,0.001C183.205,0,183.554,0,183.903,0.001z" />
                  <polygon style="fill:#fff;"
                  points="285.78,133.225 155.168,263.837 82.025,191.217 111.805,161.96 155.168,204.801    256.001,103.968  " />
             </svg>`,
        error: `
             <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                 <path style="fill:#FF3636;" d="M256,0C115.3,0,0,115.3,0,256s115.3,256,256,256s256-115.3,256-256S396.7,0,256,0z"/>
                 <path style="fill:#F40000;" d="M512,256c0,140.7-115.3,256-256,256V0C396.7,0,512,115.3,512,256z"/>
                 <polygon style="fill:#fff;" points="298.299,256 383.2,340.901 340.901,383.2 256,298.299 171.099,383.2 128.8,340.901 
                 213.701,256 128.8,171.099 171.099,128.8 256,213.701 340.901,128.8 383.2,171.099 "/>
                 <polygon style="fill:#f4f4f4;" points="298.299,256 383.2,340.901 340.901,383.2 256,298.299 256,213.701 340.901,128.8 
                 383.2,171.099 "/>
             </svg>`,
        warning: `
                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	             viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
            <path style="fill:#3B4145;" d="M322.939,62.642l178.737,309.583C508.231,383.578,512,396.74,512,410.791
	            c0,42.67-34.592,77.264-77.264,77.264H256L194.189,256L256,23.946C284.62,23.946,309.587,39.519,322.939,62.642z"/>
            <path style="fill:#525A61;" d="M189.061,62.642L10.323,372.225C3.769,383.578,0,396.74,0,410.791
	            c0,42.67,34.592,77.264,77.264,77.264H256V23.946C227.38,23.946,202.413,39.519,189.061,62.642z"/>
            <path style="fill:#FFB751;" d="M474.913,387.678L296.177,78.098c-8.056-13.959-22.849-22.767-38.848-23.22l152.869,402.275h24.539
	            c25.559,0,46.358-20.798,46.358-46.358C481.095,402.677,478.952,394.683,474.913,387.678z"/>
            <path style="fill:#FFD764;" d="M444.853,387.678c3.492,7.005,5.336,14.999,5.336,23.117c0,25.559-17.935,46.358-39.992,46.358
	            H77.264c-25.559,0-46.358-20.799-46.358-46.358c0-8.118,2.143-16.112,6.181-23.117l178.736-309.58
	            c8.283-14.34,23.674-23.251,40.177-23.251c0.443,0,0.886,0.01,1.329,0.031c13.732,0.536,26.414,9.323,33.326,23.22L444.853,387.678z
	            "/>
            <path style="fill:#3B4145;" d="M256,354.131v51.509c14.227,0,25.755-11.528,25.755-25.755
	            C281.755,365.659,270.227,354.131,256,354.131z"/>
            <path style="fill:#525A61;" d="M256,354.131c2.843,0,5.151,11.528,5.151,25.755c0,14.227-2.308,25.755-5.151,25.755
	            c-14.227,0-25.755-11.528-25.755-25.755C230.245,365.659,241.773,354.131,256,354.131z"/>
            <path style="fill:#3B4145;" d="M256,132.646V323.23c14.227,0,25.755-11.538,25.755-25.755V158.401
	            C281.755,144.174,270.227,132.646,256,132.646z"/>
            <path style="fill:#525A61;" d="M256,132.646c2.843,0,5.151,11.528,5.151,25.755v139.074c0,14.216-2.308,25.755-5.151,25.755
	            c-14.227,0-25.755-11.538-25.755-25.755V158.401C230.245,144.174,241.773,132.646,256,132.646z"/>
            </svg>`
    }

    let button = `<button class="message-box__button ${type}">${buttonText}</button>`

    if (ask) {
        button = `
            <div class="u-flex-between btnClass">
                <button class="message-box__button ${type}">Confirmar</button>
                <button class="message-box__button ${type}">Cancelar</button>
            </div>`
    }

    const box = document.createElement('div')
    box.id = 'box-' + random()
    box.classList = `message-box ${isMobile ? 'mobile' : 'web'} ${classList ? classList : ''
        }`
    box.innerHTML = `
            <div class="message-box__container animate__animated animate__zoomIn ${ask ? 'ask' : ''
        }">
                <div class="message-box__icon ${type}">
                ${icon[type]}
                </div>
                <div class="message-box__title">${title}</div>
                <div class="message-box__message">${message}</div>
                ${button}
            </div>`
    document.body.appendChild(box)

    callback && typeof callback === 'function' && callback(box.id)
}

export const showMessageBox = (options) => {

    let id = options.id
    if (!id) {
        id = "msg-" + random()
    }

    let [icon, classList, buttons] = ['', '', '']

    icon = options.icon ? '/images/global/messagebox/' + options.icon + '.svg' : ''
    classList = 'message-box ' + options.classList ? options.classList : ''

    if (options.default) {
        buttons = `<button id="message-btn-ok" class="btn-small-primary message-box__button">OK</button>`
    } else {
        if (options.buttons) {
            options.buttons.forEach((button) => {
                buttons += `<button id="${button.id}" class="message-box__button ${button.classList}">${button.text}</button>`
            })
        }
    }

    const messageBox = document.createElement('div')
    messageBox.id = id
    messageBox.classList = classList + ' message-box'
    messageBox.innerHTML = `
    <div class="message-box__container ${options.noEffect ? '' : 'animate__animated animate__zoomIn'}">
        <div class="message-box__icon">
            <img src="${icon}" ${icon ? '' : 'style=display:none'}>
        </div>
        <div class="message-box__message">${options.message}</div>
        ${options.body || ''}
        <div class="u-flex-between">
        ${buttons}
        </div>
    </div>`

    document.body.appendChild(messageBox)

    if (options.default) {
        $('#' + id + ' #message-btn-ok').on('click', () => {
            $(`#${id}`).remove()
            options.callback &&
                typeof options.callback === 'function' &&
                options.callback()
        })
    } else {
        if (options.buttons) {
            options.buttons.forEach((button) => {
                if (typeof button.callback === 'function') {
                    button.callback()
                } else {
                    console.error(
                        '[function: showMessageBox][button.callback] Não é uma função.'
                    )
                }
            })
        }
    }
}